import type { NavigateOptions } from "@tanstack/react-router"
import type { ReactNode } from "react"
import type { EntityLink } from "./model"

export default ({
  type,
  id,
  tenantSlug,
  label,
}: EntityLink): NavigateOptions & { children: ReactNode } => {
  console.log("Resolving entity link:", { type, id, tenantSlug, label })

  throw new Error("Unimplemented")
}
